export default __webpack_public_path__ + "static/media/ClaimStatus_a.a2c17bbd.png";